import { render, staticRenderFns } from "./user-activation-hist.vue?vue&type=template&id=4f0cfcc6&scoped=true&lang=pug&"
import script from "./user-activation-hist.vue?vue&type=script&lang=ts&"
export * from "./user-activation-hist.vue?vue&type=script&lang=ts&"
import style0 from "./user-activation-hist.vue?vue&type=style&index=0&id=4f0cfcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0cfcc6",
  null
  
)

export default component.exports